module.exports = __webpack_public_path__ + "img/blue_016.9c62f87a.png";